import type { ProductConfig } from './product.types';

export const productConfig: ProductConfig = {
  activeABTests: {},
  aiUspPbks: [],
  aplus: {
    enabled: true,
  },
  cliplister: {
    consentGroup: 'C0004',
    customerId: '',
    enabled: true,
    scriptUrl:
      'https://mycliplister.com/merge?cliplister=1.6&clviewer=1.23&videostage=1.18&innercontrols=1.7&clickablevideo=1.4&playbutton=1.1&previewimage=1.4&bufferingspinner=1.5&nextbutton=1.2&autoplaynext=1.1',
  },
  expressServiceEnabled: false,
  hasKIM: true,
  hasScarcity: true,
  hasTransparentSection: false,
  powerSupply: {
    pictogram: {
      included: 'https://bilder.baur.de/i/empiriecom/FuAG_included.svg',
      notIncluded: 'https://bilder.baur.de/i/empiriecom/FuAG_not_included.svg',
      specification: 'https://bilder.baur.de/i/empiriecom/FuAG_specifications.svg',
    },
  },
  price: {
    showDiscountFlag: true,
    useSpecialColorForDiscounts: true,
  },
  recommendations: {
    atb: {
      slots: {
        1: 'prudsysAddToBasket',
        2: 'miraklProducts',
      },
    },
    dv: {
      slots: {
        1: 'prudsysProducts',
        2: 'seriesProducts',
        3: null,
        4: 'similarProducts',
      },
    },
    // INFORM-4234 This is only for sequence changing for swimwear. Please remove them, when you don't need it anymore.
    dvSwimwear: {
      slots: {
        1: 'seriesProducts',
        2: 'prudsysProducts',
        3: null,
        4: 'similarProducts',
      },
    },
    // INFORM-4234 List of swimwear pbks.
    swimwearPbks: ['Badeanzüge', 'Badehosen', 'Badekappen', 'Bikini-Oberteile', 'Bikini-Sets'],
    // INFORM-4234 Check if the tenant is using prudsys. Default is yes and only LAT and LCH are false.
    isUsingPrudsys: true,
  },
  reviews: {
    hintLayerId: 'hint_kdbe_verifiziert',
  },
  seoImageParams: null,
  serviceLayer: {
    paymentMethods: null,
  },
  taxHint: {
    hideAdditionalDeliveryInfo: false,
    modalContent: {
      DEFAULT: {
        link: 'delivery_default',
      },
      L: {
        link: 'delivery_spedition-layer-L',
      },
      S: {
        link: 'delivery_spedition-layer-S',
      },
    },
  },
  usps: ['INVOICE', 'FLEXIKONTO', '30_DAYS_RETURN'],
  voucherPrice: {
    enabled: true,
  },
};
